// react
import { useContext } from 'react';

// context
import { ContextPaymentRefunds } from '../../Project.context';

// mui
import { Container, Grid } from '@mui/material';

// tables
import { TablePaymentRefunds } from '../../../../tables/cards/TablePaymentRefunds/TablePaymentRefunds';

export const PaymentRefunds = () => {
	// context
	const {
		isLoadingPaymentRefunds,
		paginationPaymentRefunds,
		refetchPaymentRefunds,
		paymentRefunds,
	} = useContext(ContextPaymentRefunds);

	return (
		<Container maxWidth={false}>
			<Grid container spacing={2}>
				<Grid item xs={12}>
					<TablePaymentRefunds
						isLoading={isLoadingPaymentRefunds}
						pagination={paginationPaymentRefunds}
						refetchTransactions={refetchPaymentRefunds}
						transactions={paymentRefunds}
					/>
				</Grid>
			</Grid>
		</Container>
	);
};
